// libs
import React, { memo, useContext } from "react";
import get from "lodash/get";

// context
import MenuContext from "shared/components/Header/DesktopHeader/components/Menu/MenuContext";

// constants
import { MENU_TYPE, MENU_MODES } from "shared/components/Header/constants";

// styles
import { SubCategoryWrapper } from "./styles";

// helpers
import { generateTrackingUrlForMegaMenu } from "shared/components/Header/helpers";

interface ISubCategoryProps {
    data: Menu.IChildrenData;
    bigItem?: boolean;
    className?: string;
}

function SubCategory({ data, bigItem = false, className = "" }: ISubCategoryProps) {
    const children = get(data, "children", []);
    const { goToUrl } = useContext(MenuContext);

    const isMenuManual = get(data, "mode", "").toUpperCase() === MENU_MODES.MANUAL;

    const titleCss = ["sb-title", isMenuManual && "sb-manual", bigItem && "sb-title-big"]
        .filter(Boolean)
        .join(" ");
    const itemCss = ["sb-item", bigItem && "sb-item-big"].filter(Boolean).join(" ");

    return (
        <SubCategoryWrapper className={className}>
            <div className={titleCss}>{data.title}</div>
            <ul className="sb-list">
                {children
                    .filter(child => child.isActive)
                    .map((childData, idx: number) => {
                        const child = { ...childData, position: idx + 1 };

                        const onClick: React.MouseEventHandler = e => {
                            e.preventDefault();
                            goToUrl(child);
                        };

                        const isLink = child.type === MENU_TYPE.SUB_LINK_HIGHLIGHT;
                        const linkCss = [itemCss, isLink && "sb-link"].filter(Boolean).join(" ");
                        return (
                            <li key={idx}>
                                <a
                                    href={generateTrackingUrlForMegaMenu(child)}
                                    className={linkCss}
                                    onClick={onClick}
                                >
                                    {child.title}
                                </a>
                            </li>
                        );
                    })}
            </ul>
        </SubCategoryWrapper>
    );
}

export default memo(SubCategory);
